var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgThumbUpSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0932 4.29883C10.0932 3.60847 10.6529 3.04883 11.3432 3.04883H12.0695C13.1866 3.04883 14.1345 3.86845 14.2959 4.97385L14.7337 7.97314C14.7516 8.09596 14.8569 8.18703 14.981 8.18703H18.3942C19.8267 8.18703 20.8944 9.50796 20.5942 10.9087L18.9029 18.7981C18.6805 19.8354 17.7638 20.5764 16.7029 20.5764H8.31299C8.33941 20.4555 8.35333 20.33 8.35333 20.2012V9.37695C8.35333 9.28814 8.34671 9.20086 8.33394 9.1156L8.89582 8.81819C9.63247 8.42827 10.0932 7.66307 10.0932 6.82959V4.29883Z",
    fill: "#323544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60352 8.62671H4.60352C3.91316 8.62671 3.35352 9.18635 3.35352 9.87671V19.7009C3.35352 20.3913 3.91316 20.9509 4.60352 20.9509H6.62284C7.02812 20.9407 7.35352 20.6089 7.35352 20.2012V9.37695C7.35352 8.96274 7.01773 8.62671 6.60352 8.62671Z",
    fill: "#323544"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpSelected);
export default __webpack_public_path__ + "static/media/thumb-up-selected.9532282fffe333377767f78cddc2900c.svg";
export { ForwardRef as ReactComponent };